import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    IHostLicense,
    ITenantLicense,
} from '@models';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class HostLicenseService extends ODataService<IHostLicense, number> {
    protected _endpoint = '/odata/HostLicenses';

    constructor(
        http: HttpClient,
    ) {
        super(http, MapperService.hostLicenseMap);
    }

    public getLicenseForTenant(tenantId: number) {
        const tenantLicenseEndpoint =
            `${this._endpoint}/UiPath.Server.Configuration.OData.GetTenantLicense(tenantId=${tenantId})`;

        return this._http
            .get(tenantLicenseEndpoint)
            .pipe(
                map((response) => this._mapData(response)),
            ) as Observable<IHostLicense>;
    }

    public setLicenseForTenant(licenseConfiguration: ITenantLicense) {
        const setTenantLicenseEndpoint =
            `${this._endpoint}/UiPath.Server.Configuration.OData.SetTenantLicense`;

        const mapperDefinition = MapperService.tenantLicenseMap;

        const payload = {
            license: this._toPoco(licenseConfiguration, mapperDefinition),
        };

        return this._http
            .post(setTenantLicenseEndpoint, payload);
    }

    public deleteLicenseForTenant(tenantId: number) {
        const deleteTenantLicenseEndpoint =
            `${this._endpoint}/UiPath.Server.Configuration.OData.DeleteTenantLicense`;

        const payload = JSON.stringify({
            tenantId,
        });

        return this._http
            .post(deleteTenantLicenseEndpoint, payload);
    }
}
